import { useCallback } from 'react';
import { ToastOptions, toast } from 'react-toastify';
import { useAtomValue } from 'jotai';
import { currentThemeNameState } from '@modules/application/atoms';


const defaultToastOptions: ToastOptions = { position: 'top-center', autoClose: 5000, };
const successToastOptions: ToastOptions = { ...defaultToastOptions, autoClose: 2000 };

export const useNotification = () => {
  const theme = useAtomValue(currentThemeNameState);
  const toastTheme = theme === 'dark' ? 'dark' : 'light';
  const notifySuccess = useCallback((message: string) => {
    toast.success(message, { ...successToastOptions, theme: toastTheme });
  }, [toastTheme]);

  const notifyFailure = useCallback((message: string) => {
    toast.error(message, { ...defaultToastOptions, theme: toastTheme });
  }, [toastTheme]);

  const notifyFailures = useCallback((messages: string[]) => {
    toast.error((
      <ul>
        {messages.map((message, index) => <li key={`error${index}`}>{message}</li>)}
      </ul>
    ), { ...defaultToastOptions, theme: toastTheme });
  }, [toastTheme]);

  return { notifySuccess, notifyFailure, notifyFailures };
};